export const formatRelatedProducts = (data: any) => {
  if (!data || typeof data !== "string") return data

  // Kiểm tra nếu data chưa có thẻ HTML (dữ liệu thô từ DB hoặc copy-paste)
  if (!data.includes("<p>") && !data.includes("<br")) {
    // Thay thế các khoảng trắng (hoặc dấu phẩy) thành xuống dòng trong CKEditor
    return data
      .trim()
      .split(/\s+/)
      .map(item => `<p>${item}</p>`)
      .join("")
  }
  return data
}
